module.exports = "/* Add your custom Handlebars helpers here.\r\n\r\nFor example:\r\n\r\nHandlebars.registerHelper('transform', function (options) {\r\n  var result = options.fn(this);\r\n  return new Handlebars.SafeString(\r\n    result.replace(/<pre[^>]*>/g, '<pre class=\"prettyprint\">')\r\n  );\r\n});\r\n\r\nThen use the helper in your template:\r\n\r\n{{#transform}}{{{files.0.content.html}}}{{/transform}}\r\n*/\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/data/empties/emptyTemplateHelpers.js
// module id = 1594
// module chunks = 1